import styles from "./Loading.module.css";
import Spinner from "./Spinner";

function Loading({ loadingText = "Loading..." }) {
  return (
    <div className={styles.loading}>
      <Spinner>
        <p>{loadingText}</p>
      </Spinner>
    </div>
  );
}
export default Loading;
